import Header from '../../components/Header';
import Terms from './components/Terms';

const TermsOfService = () => {
  return (
    <>
      <div className='page-bg'>
        <Header />
        <Terms />
      </div>
    </>
  );
};

export default TermsOfService;
